export const TimeFrames = [
    {
      label: "1D",
      value: 1,
    },
    {
      label: "7D",
      value: 7,
    },
    {
      label: "1M",
      value: 30,
    },
    {
        label: "3M",
        value: 92,
      },
    {
      label: "1Y",
      value: 365,
    }
  ];